module.exports = __webpack_public_path__ + "img/fenetres.b18db8a3.svg";